import { Component, OnInit } from '@angular/core';
import { WorkflowComponent } from '../../workflow.component';
import { Subscription } from 'src/app/subscription/subscription.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Model } from 'src/app/app.model';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { WorkflowPartnerService } from '../workflow-partner.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-workflow-partner-ai-tariff-order-cancel',
  templateUrl: './workflow-partner-ai-tariff-order-cancel.component.html',
  standalone: false
})
export class WorkflowPartnerAiTariffOrderCancelComponent extends WorkflowComponent implements OnInit {

  public subscription: Subscription;

  constructor(
    protected route: ActivatedRoute,
    protected m: Model,
    protected router: Router,
    protected subscriptionService: SubscriptionService,
    protected workflowPartnerService: WorkflowPartnerService,
  ) {
    super();
  }

  async ngOnInit() {
    super.ngOnInit();
    this.setStep('order-cancel');
    this.subscriptionService.getSubscriptionDetails(+this.applianceId).subscribe({
      next: (r) => {
        this.subscription = Subscription.fromJson(r);
        this.applianceId = this.subscription.appliance_id;
      },
      error: (err) => {
        this.router.navigate(['/subscriptions']);
        this.resetWorkflow();
      }
    });
  }

  private setStep(step: string) {
    this.step = step;
  }

  onBack() {
    this.resetWorkflow();
  }

  async onConfirm() {
    try {
      const orderWithAiTariff = this.subscription?.scheduledAITariffOrder;

      if (orderWithAiTariff) {
        await firstValueFrom(this.workflowPartnerService.oneApplianceCancelTariffOrder(orderWithAiTariff.name));
      }
      this.resetWorkflow();
    } catch (e) {
      this.resetWorkflow();
    }
  }

}
